import React from "react";
import { Check } from "lucide-react";

export default function PlanCard({ plan }) {
  const highlight = plan.highlight;
  return (
    <div
      data-testid={`plan-card-${plan.id}`}
      className={`relative flex flex-col rounded-sm border p-7 transition-colors ${
        highlight
          ? "border-gold bg-gradient-to-b from-gold/10 to-transparent lg:scale-105 shadow-2xl shadow-gold/10 z-10"
          : "border-white/12 bg-[#101010] hover:border-white/25"
      }`}
    >
      {plan.badge ? (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-black font-heading font-600 text-[11px] tracking-widest px-4 py-1 rounded-sm" data-testid={`plan-badge-${plan.id}`}>
          {plan.badge}
        </span>
      ) : null}
      <h3 className="font-heading font-700 uppercase text-xl text-white tracking-tight">{plan.name}</h3>
      <p className="text-zinc-400 text-sm mt-2 leading-relaxed min-h-[40px]">{plan.description}</p>
      <div className="mt-5 flex items-end gap-1">
        <span className={`font-heading font-700 text-3xl ${highlight ? "text-gold" : "text-white"}`}>{plan.price}</span>
        <span className="text-zinc-500 text-sm mb-1">{plan.period}</span>
      </div>
      <ul className="mt-6 space-y-3 flex-1">
        {(plan.features || []).map((f, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm text-zinc-300">
            <Check className={`w-4 h-4 mt-0.5 shrink-0 ${highlight ? "text-gold" : "text-zinc-500"}`} />
            <span>{f}</span>
          </li>
        ))}
      </ul>
      <a
        href={plan.signup_url}
        target="_blank"
        rel="noreferrer"
        data-testid={`plan-cta-${plan.id}`}
        className={`mt-7 inline-flex items-center justify-center font-heading font-600 tracking-wide px-5 py-3.5 rounded-sm transition-colors ${
          highlight ? "bg-gold hover:bg-gold-hover text-black" : "border border-white/25 text-white hover:border-gold hover:text-gold"
        }`}
      >
        {plan.cta}
      </a>
    </div>
  );
}
